module.exports = __webpack_public_path__ + "static/village_slide_img02-22308f21a543fe82f4db7570bfd834a6.png";